import NavigationBullet from "@components/atoms/NavigationBullet";
import React from "react";
import styled from "styled-components/native";

type NavigationBulletProps = {
  selected: number;
  size: number;
  bulletWidth?: string;
  shape?: string;
  changeSelectedIndex: any;
};

const NavigationBullets = ({
  selected,
  size,
  bulletWidth,
  shape,
  changeSelectedIndex,
}: NavigationBulletProps) => {
  const borderRadius = shape === "square" ? "0px" : "10px";
  bulletWidth = bulletWidth ?? "8px";

  let bulletListing = [];
  for (let i = 0; i < size; i++) {
    bulletListing.push(
      <NavigationBullet
        key={i}
        selected={selected === i}
        borderRadius={borderRadius}
        bulletWidth={bulletWidth}
        changeSelectedIndex={() => changeSelectedIndex(i)}
      />
    );
  }

  return <NavigationBulletView>{bulletListing}</NavigationBulletView>;
};

const NavigationBulletView = styled.View`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export default NavigationBullets;
